/*
 * Maison Perle: keeps product videos playing on phones.
 * - Forces the muted/inline flags iOS and Android need for autoplay.
 * - Plays a video when it is on screen, pauses it when it scrolls or swipes away.
 * - Resumes after the theme pauses everything (e.g. after closing the zoom modal).
 * - If the browser blocks autoplay (iPhone Low Power Mode, Android Data Saver),
 *   starts playback on the shopper's first tap or swipe.
 */
(function () {
  if (window.__mpInlineVideo) return;
  window.__mpInlineVideo = true;

  var visible = new Set();

  function prep(video) {
    if (video.__mpPrepped) return;
    video.__mpPrepped = true;
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.loop = true;
  }

  function tryPlay(video) {
    if (!video.isConnected || document.hidden) return;
    var openModal = document.querySelector('.product-media-modal[open]');
    if (openModal && !openModal.contains(video)) return;
    if (video.offsetParent === null && getComputedStyle(video).position !== 'fixed') return;
    prep(video);
    if (video.preload === 'none') video.preload = 'metadata';
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  var io =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var v = entry.target;
              if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
                visible.add(v);
                tryPlay(v);
              } else {
                visible.delete(v);
                v.pause();
              }
            });
          },
          { threshold: [0, 0.35, 0.6] }
        )
      : null;

  function register(root) {
    (root || document).querySelectorAll('video.mp-inline-video').forEach(function (v) {
      if (v.__mpObserved) return;
      v.__mpObserved = true;
      prep(v);
      if (io) io.observe(v);
      else tryPlay(v);
    });
  }

  function resumeVisible() {
    visible.forEach(tryPlay);
  }

  // The desktop thumbnail strip also contains autoplaying full-HD videos. On phones that strip
  // is hidden, but the videos would still download in the background and starve the main video.
  function stopHiddenThumbVideos() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.thumbnail-slider video:not(.mp-inline-video)').forEach(function (v) {
      if (v.__mpStopped || v.offsetParent !== null) return;
      v.__mpStopped = true;
      v.pause();
      v.removeAttribute('autoplay');
      v.preload = 'none';
      v.querySelectorAll('source').forEach(function (s) { s.remove(); });
      v.removeAttribute('src');
      try { v.load(); } catch (e) {}
    });
  }

  function init() {
    stopHiddenThumbVideos();
    register(document);

    // Theme re-renders the gallery when a variant changes.
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) {
          stopHiddenThumbVideos();
          register(document);
          break;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    // Theme calls pauseAllMedia() when the zoom modal opens/closes or a thumbnail is clicked.
    document.body.addEventListener('modalClosed', function () {
      setTimeout(resumeVisible, 150);
    });
    document.addEventListener('click', function () {
      setTimeout(resumeVisible, 350);
    });

    // Autoplay blocked (Low Power Mode / Data Saver): a first touch unlocks playback.
    var unlock = function () {
      resumeVisible();
      document.removeEventListener('touchstart', unlock);
      document.removeEventListener('pointerdown', unlock);
    };
    document.addEventListener('touchstart', unlock, { passive: true });
    document.addEventListener('pointerdown', unlock, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) resumeVisible();
    });
    window.addEventListener('pageshow', resumeVisible);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
